import axios from "axios";
export const axiosInstance = axios.create({
  baseURL: "/api/", // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  // timeout: 10000,    // 요청 타임아웃 설정 (10초)
  // withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const risingInstance = axios.create({
  baseURL: "/api/", // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  timeout: 10000, // 요청 타임아웃 설정 (10초)
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const chartInstance = axios.create({
  baseURL: "https://chart-api.risingx.io", // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  timeout: 10000, // 요청 타임아웃 설정 (10초)
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const risingInstance2 = axios.create({
  baseURL: "http://121.133.75.223:8000/", // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  // timeout: 10000, // 요청 타임아웃 설정 (10초)
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const risingAPI = axios.create({
  // baseURL env로 변경해야함
  baseURL: process.env.VUE_APP_API_BASE_URL, // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  // timeout: 10000, // 요청 타임아웃 설정 (10초)
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const briefAPI = axios.create({
  baseURL: "https://video.blocksquare.tech/video/", // 프록시 설정을 통해 `/api/`로 시작하는 요청이 Express 서버로 전달됨
  // timeout: 10000, // 요청 타임아웃 설정 (10초)
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});


export const API6 = axios.create({
  baseURL: "https://chart-api.blocksquare.tech/",
  headers: {
    Accept: "*/*",
  },
});

//trading api
export const API7 = axios.create({
  // baseURL: "http://3.39.43.25/",
  baseURL: "https://trad.risingx.io/",
  headers: {
    Accept: "*/*",
  },
});

export const devConfig = {
  baseUrl: "https://chart-api.blocksquare.tech",
  scoreUrl: "https://won.korbot.com/page/predict_chart_api.php",
};
